import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest, getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";
import { addToLoader } from "../loader/loaderSlice";
import { useNavigate } from "react-router-dom";

const initialState = {
    data: {},
    loading: true,
    error: false,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const getCustomerHolidayItineraries = createAsyncThunk(
    "customerHolidayItineraries/get",
    async (
        { unique_code = "", isPreview = false, language = window.currentLanguage.toString(), isLegend = false },
        thunkAPI
    ) => {
        let payload = {
            data: {
                is_pagination: 0,
                language: language,
            },
        };
        if (getUserDetails()) payload.data.user_uid = getUserDetails().user_details.uid;
        // V2: payloads unchanged. Per the BE source these V2 methods keep V1's WHERE logic verbatim
        // and only accept `agency_id` for echo-back — it does not scope the query — so there is no
        // wire key to rename here. Only the request_type moves.
        let request_type = requestType.getCustomerHolidayItinerariesV2;
        if (unique_code) {
            payload.data = {};
            payload.data = {
                link_code: unique_code,
                language: language,
                is_preview: 0,
            };

            // console.log("window.location.pathname", window.location.pathname);
            const temp = [
                "preview",
                "your-cruise",
                "why-royal",
                "what-included",
                "contact",
                "itinerary",
                "itinerary-ship",
                "itinerary-day",
                "itinerary-seaday",
            ];
            let checkPreview = 0;
            temp.forEach((item) => {
                if (window.location.pathname.includes(item)) {
                    checkPreview++;
                }
            });

            if (checkPreview) {
                if (getUserDetails()) payload.data.user_uid = getUserDetails().user_details.uid;
                payload.data.is_preview = 1;
            }
            request_type = isLegend
                ? requestType.getLinkDetailsLegendV2
                : requestType.getLinkDetailsV2;
        }
        const response = await apiRequest({
            payload: payload,
            requestType: request_type,
        });

        if (response.data?.error_code === "ERROR_INVALID_LINK_CODE") {
            return response.data?.error_code;
        }
        if (response.data?.data?.length) return response.data.data[0];
        return response.data.data;
    }
);

export const itineraryRegionsSlice = createSlice({
    name: "customerHolidayItineraries",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {},
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getCustomerHolidayItineraries.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCustomerHolidayItineraries.fulfilled, (state, { payload }) => {
                // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
                state.loading = false;
                state.data = payload;
            })
            .addCase(getCustomerHolidayItineraries.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.customerHolidayItineraries.value)`
export const selectCustomerHolidayItineraries = (state) => state.customerHolidayItineraries;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.

export default itineraryRegionsSlice.reducer;
